import React from 'react';
import { CONTACT_EMAIL } from '../config/contact';
import './Stats.css';

const Stats = () => {
  return (
    <section className="stats" id="cta">
      <div className="stats-container">
        <h2 className="cta-title">Understand Our Approach to Prediction Markets</h2>
        <a href={`mailto:${CONTACT_EMAIL}`} className="btn-cta">
          Contact TQS →
        </a>
      </div>
    </section>
  );
};

export default Stats;
